<template lang="pug">
  div
    el-row.container(type="flex")
      app-card-dashboard(title="Total de processos de arrecadação" :content="this.dadosCards.quantidadeTotal || '0'" color="red" :style="{'marginLeft': 0}" :marginTop="0")
      app-card-dashboard(title="Processos em arrecadação" :content="this.dadosCards.quantidadeEmArrecadacao || '0'" color="yellow" :style="{'marginLeft': 0}" :marginTop="0")
      app-card-dashboard(title="Processos de arrecadação concluídos" :content="this.dadosCards.quantidadeArrecadada || '0'" color="#3d9c67" :style="{'marginLeft': 0}" :marginTop="0")
    el-row.container(type="flex")
      card-area(title='Total de áreas' :value="this.dadosCards.areaTotal || 0")
      card-area(title='Áreas em arrecadação' :value="this.dadosCards.areaTotalEmArrecadacao || 0")
      card-area(title='Áreas arrecadadas' :value="this.dadosCards.areaTotalArrecadada || 0")
    el-row.container-grafico
      h3 Gráfico
      abas-grafico(@tabChanged='alterarGrafico($event)')
      filtro-relatorios(@filtrar='filtrar($event)' @limpar='limpar()')
      div.container#opcoes-periodo(type="flex" v-if='this.abaAtiva === "PERIODO"')
        div.opcao-periodo#day(@click='changeTipoData("diario")')
          span Diário
        div.opcao-periodo#month(@click='changeTipoData("mensal")')
          span Mensal
        div.opcao-periodo#year(@click='changeTipoData("anual")')
          span Anual
      grafico(
        v-if='showGrafico'
        idDiv="sample"
        :dados="dadosGrafico"
        keyX="dadoNominal"
        keyY="dadoQuantitativo"
        keyText="quantidade"
        :showTituloGrafico="false"
        :tituloX="this.tituloX"
        :tituloY="this.tituloY"
        :cores="this.cores"
        :style="{'box-shadow': '0 2px 12px 0 rgba(0, 0, 0, 0.1)'}"
        :zoom=false
        :switchText="this.switchText"
      )
      el-row.tableContainer(
        v-if='!showGrafico'
        )
        el-table(
          :data='dadosGraficoTabela'
          style="padding: 30px; overflow: auto; height: 400px;"
          )
          el-table-column(
            prop="dadoNominal",
            :label="this.tituloX"
          )
          el-table-column(
            prop="dadoQuantitativo",
            :label="this.tituloY"
          )
      el-row(type="flex")
        el-radio-group(v-model="showGrafico")
          el-radio-button(:label="true") Gráfico
          el-radio-button(:label="false") Tabela
      el-row.container-switch(type="flex")
        span Por quantidade de processos
        el-switch(
          v-model="switchValue"
          active-color="#4dd863"
          inactive-color="#a7a7a7"
        )
        span.areaSpan Por área (em ha)
        el-button(type="primary" @click='exportar')#export-button Exportar

    el-row.container-grafico(style="marginTop: 3%")
      h3 Processos
      filtro-relatorios(
        @filtrar='filtrarProcessos($event)'
        @limpar='limparProcessos()'
        :showNumeroProcesso='true'
      )
      h3(style="marginTop: 1%; marginLeft : 1%") Listagem de Processos
      table-generica(
        :colunas="colunas",
        :botoesAcao="botoesAcao",
        :dados='processos',
        :sortChanged='sortChanged'
      )
      el-row.container-switch(type="flex" style="marginTop: 1%")
        app-paginacao(
          :total="totalProcessos"
          :pagina="pagina",
          @changePage="changePage($event)"
        )
        el-button(type="primary" @click='exportarProcessos')#export-button Exportar

    app-modal(titulo="Visualizar processo" v-if='showModal' @closeModal='showModal = false')
      template(slot="body")
        analise-processo(
          routeListagemName="arrecadacao/relatorios"
          :isVisualizar='true'
          :idProcesso='this.idProcessoSelecionado'
        )

</template>

<script>
import { mapActions } from 'vuex'
import CardArea from './components/CardArea'
import AbasGrafico from './components/AbasGrafico'
import FiltroRelatorios from './components/FiltroRelatorios'
import AppCardDashboard from '@/components/AppCardDashboard'
import AppModal from '@/components/AppModal'
import AppPaginacao from '@/components/AppPaginacao'
import Grafico from '@/screens/demandas/components/Grafico'
import TableGenerica from '@/components/TableGenerica'
import GRAFICO from '@/constants/grafico'
import parametros from './constants/tipoParametros'
import AnaliseProcesso from '@/screens/arrecadacao/components/AnaliseProcesso'
import domtoimage from 'dom-to-image'
import Util from '@/utils/utils'
import _ from 'lodash'

export default {
  beforeRouteLeave (to, from, next) {
    document.title = 'SiCARF'
    next()
  },

  components: {
    CardArea,
    AppCardDashboard,
    Grafico,
    AbasGrafico,
    FiltroRelatorios,
    TableGenerica,
    AppPaginacao,
    AppModal,
    AnaliseProcesso
  },

  data () {
    return {
      dadosCards: {},
      dadosGrafico: [],
      dadosGraficoTabela: [],
      tableData: [],
      processos: [],
      showModal: false,
      idProcessoSelecionado: null,
      totalProcessos: 0,
      filtro: parametros.FILTRO_EMPTY,
      filtroProcessos: parametros.FILTRO_EMPTY,
      tipoQuery: parametros.DEFAULT.tipoQuery,
      parametroQuery: parametros.DEFAULT.parametroQuery,
      tituloY: parametros.DEFAULT.tituloY,
      tituloX: parametros.DEFAULT.tituloX,
      cores: GRAFICO.CORES_ARRECADACAO,
      switchValue: parametros.DEFAULT.switchValue,
      abaAtiva: parametros.DEFAULT.abaAtiva,
      showGrafico: parametros.DEFAULT.showGrafico,
      tipoData: parametros.TIPO_DATA.mensal,
      switchText: {
        texto: 'processos',
        template: '%{y}'
      },
      colunas: [
        {
          prop: 'numeroProcesso',
          label: 'Processo',
          width: 'auto',
          formatter: Util.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'cadastroColetivo.pecaTecnica.gleba',
          label: 'Gleba',
          width: 'auto',
          formatter: Util.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'cadastroColetivo.pecaTecnica.municipios',
          label: 'Município',
          width: 'auto',
          formatter: Util.formatMunicipio,
          sortable: 'custom'
        },
        {
          prop: 'setor',
          label: 'Setor',
          width: 'auto',
          formatter: Util.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'statusName',
          label: 'Situação',
          width: 'auto',
          formatter: Util.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'dataChegadaSetor',
          label: 'Última movimentação',
          width: 'auto',
          formatter: Util.formatEmptyRow,
          sortable: 'custom'
        }
      ]
    }
  },

  computed: {
    pagina () {
      return this.filtroProcessos.pagina + 1
    }
  },

  methods: {
    ...mapActions({
      getDadosCards: 'relatoriosArrecadacao/dadosCards',
      getDadosGrafico: 'relatoriosArrecadacao/dadosGrafico',
      exportaCSVArrecadacao: 'relatoriosArrecadacao/exportaCSVArrecadacao',
      exportaCSVProcessosArrecadacao:
        'relatoriosArrecadacao/exportaCSVProcessosArrecadacao',
      getProcessosCadastrados: 'relatoriosArrecadacao/find',
      resetLoader: 'loader/resetLoader',
      setLoader: 'loader/setLoader'
    }),

    async alterarGrafico (abaAtiva) {
      const tipo = this.switchValue ? 'AREA' : 'QUANTIDADE'
      this.tituloY = parametros.TIPO[tipo].tituloY
      this.tipoQuery = parametros.TIPO[tipo].tipoQuery
      this.parametroQuery = parametros[abaAtiva].parametroQuery
      this.tituloX = parametros[abaAtiva].tituloX
      this.abaAtiva = abaAtiva
      await this.findDadosGrafico()
    },

    async findDadosGrafico () {
      this.dadosGrafico = await this.getDadosGrafico({
        filtro: this.filtro,
        tipo: this.tipoQuery,
        parametro: this.parametroQuery,
        tipoData: this.tipoData
      })
      this.dadosGraficoTabela = _.cloneDeep(this.dadosGrafico)
      if (this.switchValue) {
        this.dadosGraficoTabela.forEach((item) => {
          item.dadoQuantitativo = new Intl.NumberFormat('de-DE', {minimumFractionDigits: 4})
            .format(item.dadoQuantitativo)
        })
      }
      if (this.abaAtiva === 'SITUACAO') {
        this.dadosGrafico.push({
          dadoNominal: 'Total de processos',
          dadoQuantitativo:
            this.dadosGrafico[0].dadoQuantitativo +
            this.dadosGrafico[1].dadoQuantitativo
        })
        this.dadosGraficoTabela = _.cloneDeep(this.dadosGrafico)
      }
      if (this.abaAtiva === 'PERIODO') {
        this.dadosGrafico.forEach((item) => {
          item.dadoNominal = item.dadoNominal[0].toUpperCase() + item.dadoNominal.substring(1)
        })
        this.dadosGraficoTabela = _.cloneDeep(this.dadosGrafico)
      }
    },
    async filtrar (dados) {
      this.filtro = dados
      await this.findDadosGrafico()
    },

    async filtrarProcessos (dados) {
      this.filtroProcessos = dados
      await this.findProcessosCadastrados()
    },

    async limpar () {
      this.filtro = parametros.FILTRO_EMPTY
      await this.findDadosGrafico()
    },

    async limparProcessos (dados) {
      this.filtroProcessos = parametros.FILTRO_EMPTY
      await this.findProcessosCadastrados()
    },

    formatDate (data, formato) {
      return Util.formatDate(data, formato)
    },

    async exportar () {
      if (this.showGrafico) {
        this.setLoader()
        const that = this
        const exportDate = this.formatDate(new Date(), 'DD/MM/YYYY_HH:mm:ss')
        const blob = await domtoimage.toBlob(document.getElementById('sample'))
        window.saveAs(blob, 'Grafico_Arrecadação_' + exportDate + '.png')
        that.resetLoader()
      } else {
        const dados = {
          items: this.dadosGrafico,
          labelNominal: this.tituloX,
          labelQuantitativa: this.tituloY
        }
        this.exportaCSVArrecadacao(dados)
      }
    },

    async exportarProcessos () {
      this.exportaCSVProcessosArrecadacao(this.filtroProcessos)
    },

    async changeTipoData (tipo) {
      this.changeCorAbaPeriodo(this.tipoData, '#e9e9e9')
      this.tipoData = parametros.TIPO_DATA[tipo]
      this.tituloX = parametros.PERIODO.tituloX[this.tipoData]
      this.changeCorAbaPeriodo(this.tipoData, 'white')
      await this.findDadosGrafico()
      if (tipo === 'diario') {
        this.tituloX = 'Data'
      } else if (tipo === 'mensal') {
        this.tituloX = 'Mês'
      } else {
        this.tituloX = 'Ano'
      }
    },

    botoesAcao (processo) {
      return [
        {
          click: this.visualizarProcesso.bind(this, processo),
          icon: 'visibility',
          title: 'Visualizar',
          active: true
        }
      ]
    },

    visualizarProcesso (processo) {
      this.showModal = true
      this.idProcessoSelecionado = processo.id
    },

    async changePage (newPage) {
      this.filtroProcessos.pagina = newPage - 1
      await this.findProcessosCadastrados()
    },

    async findProcessosCadastrados () {
      const dados = await this.getProcessosCadastrados({
        filtro: this.filtroProcessos
      })
      this.processos = dados.processosArrecadacao
      this.totalProcessos = dados.total
    },

    changeCorAbaPeriodo (aba, color) {
      document.getElementById(aba).style.backgroundColor = color
    },

    sortChanged ({ column, prop, order }) {
      if (order) {
        const direcaoMap = {
          ascending: 'ASC',
          descending: 'DESC'
        }
        this.filtroProcessos.ordem = prop
        this.filtroProcessos.ordemDirecao = direcaoMap[order]
      }

      this.findProcessosCadastrados()
    }
  },

  async created () {
    await this.findDadosGrafico()
    this.dadosCards = await this.getDadosCards()
    document.title = 'SiCARF - Relatórios Arrecadação'
    await this.findProcessosCadastrados()
  },

  watch: {
    switchValue (val) {
      if (val) {
        this.switchText.texto = ' ha'
        this.switchText.template = '%{y:,.4f}'
        this.alterarGrafico(this.abaAtiva, 'AREA')
      } else {
        this.switchText.texto = ' processos'
        this.switchText.template = '%{y}'
        this.alterarGrafico(this.abaAtiva, 'QUANTIDADE')
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';

.container {
  display: flex;
  width: 64%;
  min-height: 100%;
  gap: 4%;
}

#opcoes-periodo {
  background-color: #e9e9e9;
  height: 6vh;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  align-items: center;
  color: black;
  gap: 0;
  width: 100%;

  .opcao-periodo {
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    width: 10%;
    cursor: pointer;
  }

  .opcao-periodo:hover {
    background-color: white;
  }

  .opcao-periodo:focus {
    background-color: white;
  }

  #month {
    background-color: white;
  }
}

#opcoes-periodo :first-child {
  border-top-left-radius: inherit;
}

.card-container {
  border-radius: 12px;
}

.titulo {
  color: $--color-primary;
  margin-top: 3px;
}

el-radio-group {
  position: absolute;
  top: -3vh;
  z-index: 1;
  left: 42%;
}

.table {
  width: 100%;
}

.button {
  display: flex;
  justify-content: flex-end;
}

.container-grafico {
  background-color: #f8f8f8;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  padding: 0.2% 1.5%;
  gap: 4%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  h3 {
    font-weight: bold;
  }

  .container-switch {
    justify-content: center;
    gap: 2%;
    font-weight: bold;
    height: 10vh;
    align-items: center;
    margin-top: 3%;
  }

  #export-button {
    right: 0;
    position: absolute;
  }
}

.el-table__row td .cell {
  text-align: center !important;
}

.el-table th > .cell {
  text-align: center;
}

.el-table--fit {
  padding: 10px;
  height: 450px;
  border-radius: 12px;
}

.el-radio-group {
  position: absolute;
  top: -23px;
  left: 42%;
  z-index: 1;
}

.tableContainer {
  width: 100%;
  height: 430px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  background-color: white;
}

.el-table::before{
  content: none;
}

@media (max-width: 780px) {
  .container {
    position: relative;
    left: 40px;
  }

  .el-radio-group {
    display: flex;
    left: 20%;
  }

  #opcoes-periodo {
    left: 0;
    justify-content: space-between;
  }

  .container-grafico .container-switch {
    margin-top: 25%;
    height: 12vh;
  }

  .container-grafico #export-button {
    bottom: 0;
  }

  .areaSpan {
    position: relative;
    right: 20px;
  }

  #day {
    position: relative;
    left: 20px;
  }

  #year {
    position: relative;
    right: 20px;
  }
}

@media screen and (min-width: 1820px){
.container {
  width: 52%;
}
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/relatorios/Home.vue